import { AsyncPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ActivityGroup, ActivityGroupDay, activityOutputContext } from '../../../interfaces/activity.interface';
import { DialogService } from '../../../services/dialog.service';
import { AvatarPipe } from '../../../shared-extra/pipes/avatar.pipe';
import { RelativeTimePipe } from '../../../shared-extra/pipes/relative-time.pipe';
import { AvatarComponent } from '../../../shared/components/avatar/avatar.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { AssetUrlPipe } from '../../../shared/pipes/asset-url.pipe';
import { GalleryTeaserUrlPipe } from '../../../shared/pipes/gallery-teaser-url.pipe';
import { ActivityPeopleDialogComponent } from '../../dialogs/activity-people-dialog/activity-people-dialog.component';

@Component({
  selector: 'app-activity-group',
  templateUrl: './activity-group.component.html',
  styleUrls: ['./activity-group.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TooltipDirective,
    SvgComponent,
    AsyncPipe,
    DatePipe,
    RelativeTimePipe,
    AssetUrlPipe,
    GalleryTeaserUrlPipe,
    AvatarPipe,
    AvatarComponent,
  ],
})
export class ActivityGroupComponent {
  @Input() group: ActivityGroup;
  @Input() day: ActivityGroupDay;
  @Input() seen: boolean;
  @Input() small: boolean;
  @Input() context: activityOutputContext;

  constructor(
    private dialog: DialogService,
    private router: Router
  ) {}

  peopleClick(event: MouseEvent) {
    if (!this.group.people.length) return;
    event.stopPropagation();
    event.preventDefault();

    if (this.group.people.length > 1) {
      this.dialog.open(ActivityPeopleDialogComponent, { people: this.group.people });
    } else {
      const person = this.group.people[0];
      this.router.navigate(['a', 'settings', 'people', person.type, person.id]);
    }

    return false;
  }
}
